import ProfileComponent from "../../../../component/profileComponent";


export default function Profile() {
    return (
        <ProfileComponent />
    );
}




